import { render, staticRenderFns } from "./ShopByCategory.vue?vue&type=template&id=a9b669fa"
import script from "./ShopByCategory.vue?vue&type=script&lang=js"
export * from "./ShopByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports